
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const whatsAppService = {
    whatsapListList,
    messageSearch,
    messageListByDate
    


};

//========= PAYMENT MADE SERVICE  =============== 
async function  whatsapListList() {
    return apiClient.get(`/whatsapp/message-list`, authHeader());
}
async function  messageSearch(searchText) {
    return apiClient.get(`/whatsapp/message-search?search=${encodeURIComponent(searchText)}`, authHeader());
}

async function  messageListByDate(dateForm) {
    return  apiClient.post(`/whatsapp/message-list-by-date`,dateForm, authHeader());
}























